import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-appkey-required-version-platform-create-dialog',
	templateUrl: './appkey-required-version-platform-create.dialog.html',
	styleUrls: ['./appkey-required-version-platform-create.dialog.scss']
})
export class AppKeyRequiredVersionPlatformCreateDialogComponent {
	public formInputs: FormGroup;

	constructor(
		private formBuilder: FormBuilder,
		private dialogRef: MatDialogRef<AppKeyRequiredVersionPlatformCreateDialogComponent>
	) {
		this.formInputs = this.formBuilder.group({
			platform: ['', [Validators.required, Validators.pattern(/\S+/)]]
		});
	}

	public onCreate(): void {
		if (!this.formInputs.valid) return;

		const platform = (this.formInputs.value.platform || '').trim();
		this.dialogRef.close(platform);
	}

	public close(): void {
		this.dialogRef.close(null);
	}
}

